import { render, staticRenderFns } from "./MobileLayout.vue?vue&type=template&id=c886a9ea&scoped=true&"
import script from "./MobileLayout.vue?vue&type=script&lang=ts&"
export * from "./MobileLayout.vue?vue&type=script&lang=ts&"
import style0 from "./MobileLayout.vue?vue&type=style&index=0&id=c886a9ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c886a9ea",
  null
  
)

export default component.exports